import AttachFileIcon from '@mui/icons-material/AttachFile';
import CommentIcon from '@mui/icons-material/Comment';
import { Badge, Box, IconButton } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import DARDocUpload from 'src/components/StartUp/documentUpload/DARDocUpload';
import Notes from 'src/components/common/Notes';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { setMessage } from 'src/store/Message';
import { useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useCommonDrugAccountability } from '../useCommonDrugAccountability';
import { useOverview } from './useOverview';
import { archLevel } from 'src/data/config';
import { DataTable } from '@pihealth/common-ui-library';
import { GridToolbarExport } from '@mui/x-data-grid-pro';

const Overview: React.FunctionComponent<any> = ({ kitData, setValue }: any) => {
  const { getOverviewKitData, overviewKitLoading } = useOverview();
  const { updateDARDoc, createDARNotes, getDARNotes, getDARNotesError, getAllDespendedData } =
    useCommonDrugAccountability();
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState<number>(10);
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG;
  const [rowsCount, setRowsCount] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const [permission, setPermission] = useState(false);
  const [notesPermission, setNotesPermission] = useState(false);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [progress, setProgrss] = useState(false);
  const [getOverViewData, setOverViewData] = useState<any>([]);
  const [filterObject, setFilterObject] = useState<any>();
  const [commentDilogOpen, setCommentDilogOpen] = useState(false);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { user } = useUser();
  const { checkPermission } = usePermissionWrapper();
  const handleComment = (row: any) => {
    setNotesPermission(true);
    setNotesData([]);
    setID('');
    setCommentDilogOpen(true);
    getNotesData(row.id);
    setID(row.id);
  };
  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg } = useFieldTranslation();
  const metaDataMock = {
    received_dispensation: {
      name: 'Drug accountability log',
      number: '10.03.06'
    },
    return: {
      name: 'IP Return Documentation',
      number: '10.03.07'
    },
    destruction: {
      name: 'IP Destruction',
      number: '10.03.09'
    },
    transfer: {
      name: 'IP Transfer Documentation',
      number: '10.03.08'
    },
    quarantine: {
      name: 'IP Retest and Expiry Documentation',
      number: '10.03.13'
    }
  };
  const [documentMetaData, setDocumentMetaData] = useState({
    name: '',
    number: ''
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDate = (params: any) => {
    return moment(params.row.da_log_kit_date_time).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`);
  };
  const formatlocationData = (params: any) => {
    return params.row.da_log_kit_location === null ? '---' : params.row.da_log_kit_location;
  };
  const formatSubjectData = (params: any) => {
    return params.row.da_log_kit_subject_id === null ? '---' : params.row.da_log_kit_subject_id;
  };
  const formatQuantityData = (params: any) => {
    if (params.row.da_log_kit_quantity === null) {
      return '---';
    } else {
      return params.row.da_log_kit_event === 'Returned' ||
        params.row.da_log_kit_event === 'Destroyed' ||
        params.row.da_log_kit_event === 'Quarantined' ||
        params.row.da_log_kit_event === 'Transferred'
        ? `-${params.row.da_log_kit_quantity}`
        : params.row.da_log_kit_event === 'Received'
        ? `+${params.row.da_log_kit_quantity}`
        : params.row.da_log_kit_quantity;
    }
  };
  const formatbalenceData = (params: any) => {
    return params.row.da_log_kit_balance_forward === null ? '---' : params.row.da_log_kit_balance_forward;
  };
  const columns = [
    {
      field: 'date_and_time',
      headerName: 'Date And Time',
      minWidth: 160,
      flex: 1,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'da_log_kit_event',
      headerName: 'Event',
      flex: 1
    },
    {
      field: 'da_log_kit_location',
      headerName: 'Location',
      flex: 1,
      valueGetter: formatlocationData
    },
    {
      field: 'da_log_kit_subject_id',
      headerName: 'Subject ID',
      flex: 1,
      valueGetter: formatSubjectData
    },
    {
      field: 'da_log_kit_quantity',
      headerName: 'Quantity',
      flex: 1,
      valueGetter: formatQuantityData,
      type: 'number'
    },
    {
      field: 'da_log_kit_balance_forward',
      headerName: 'Balance Forward',
      flex: 1,
      valueGetter: formatbalenceData,
      type: 'number'
    },
    {
      field: 'da_log_kit_initials',
      headerName: "Recorder's initials",
      flex: 1
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 90,
      flex: 1,
      filterable: false,
      renderCell: (params: any) => (
        <>
          <IconButton onClick={() => handleFileUploadOpen(params.row)} sx={{ mr: 0.5 }}>
            <AttachFileIcon color="primary" />
            <Badge badgeContent={params.row.docCount} color="primary" className="smallBadgeSearch" sx={{ mt: -2.5 }} />
          </IconButton>
          <IconButton onClick={() => handleComment(params.row)}>
            <CommentIcon sx={{ color: '#2196F3' }} />
          </IconButton>
        </>
      )
    }
  ];
  const getOverViewDrugData = async (from: number, size: number) => {
    setProgrss(true);
    let updated = [];
    const overviewKitRes: any = await getOverviewKitData({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      data: filterObject,
      country: selectedCountry,
      application: currentAppName,
      from,
      size
    });
    if (overviewKitRes.isSuccess) {
      if (overviewKitRes.data && overviewKitRes.data.selected_data.length > 0) {
        updated = overviewKitRes?.data.selected_data.map((item: any) => {
          return {
            id: item.event_data.id,
            documents_data: item.file_ids,
            docCount: item.file_ids.length,
            ...item.event_data
          };
        });
      }
    }
    const allDespendedRes: any = await getAllDespendedData({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: kitData.da_log_kit_id,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME
    });
    if (allDespendedRes?.isSuccess) {
      if (
        allDespendedRes.data &&
        allDespendedRes.data.selected_data.length > 0 &&
        (overviewKitRes.isSuccess ? overviewKitRes?.data?.record_count : 0) + allDespendedRes?.data?.record_count <
          pageSize * (pageNumber + 1)
      ) {
        allDespendedRes?.data.selected_data.map((item: any) => {
          updated.push({
            id: item.event_data.id,
            documents_data: item.file_ids,
            docCount: item.file_ids.length,
            da_log_kit_event: 'Dispensed',
            da_log_kit_date_time: item.event_data.da_log_kit_schedual_date_time,
            da_log_kit_quantity: null,
            da_log_kit_location: null,
            da_log_kit_balance_forward: null,
            ...item.event_data
          });
        });
      }
      if (overviewKitRes.isSuccess) {
        setRowsCount(overviewKitRes?.data?.record_count + allDespendedRes?.data?.record_count);
      } else {
        setRowsCount(allDespendedRes?.data?.record_count);
      }
    } else {
      setRowsCount(overviewKitRes?.data?.record_count);
    }

    setOverViewData(updated);
    if (overviewKitRes?.isError || allDespendedRes?.isError) {
      if (overviewKitRes?.isError && allDespendedRes?.isError) {
        setOverViewData([]);
      }
      const errorObj = overviewKitRes.error || allDespendedRes.error;
      if (errorObj?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (errorObj?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }

    setProgrss(false);
  };
  useEffect(() => {
    getOverViewDrugData(0, 10);
  }, []);
  useEffect(() => {
    if (!overviewKitLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getOverViewDrugData(0, pageSize);
      } else {
        getOverViewDrugData(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize]);

  useEffect(() => {
    if (filterObject) {
      getOverViewDrugData(0, pageSize);
    }
  }, [filterObject]);
  const [id, setID] = useState('');
  const [notetext, setNoteText] = useState('');
  const [notesData, setNotesData] = useState([]);
  const handleSendNote = async (_: any) => {
    if (notetext !== '') {
      sendNotesData(id);
      setNoteText('');
    }
  };
  const [uploadDilogOpen, setUploadDilogOpen] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const [progressDocUpload, setProgressDocUpload] = useState<boolean>(false);
  const handleFileUploadOpen = (row: any) => {
    if (row.da_log_kit_event === 'Returned') {
      setDocumentMetaData(metaDataMock.return);
      setPermission(checkPermission('update_kit_return_event'));
    } else if (row.da_log_kit_event === 'Destroyed') {
      setDocumentMetaData(metaDataMock.destruction);
      setPermission(checkPermission('update_kit_destruction_event'));
    } else if (row.da_log_kit_event === 'Quarantined') {
      setDocumentMetaData(metaDataMock.quarantine);
      setPermission(checkPermission('update_kit_quarantine_event'));
    } else if (row.da_log_kit_event === 'Transferred') {
      setDocumentMetaData(metaDataMock.transfer);
      setPermission(checkPermission('update_kit_transfer_event'));
    } else if (row.da_log_kit_event === 'Received') {
      setDocumentMetaData(metaDataMock.received_dispensation);
      setPermission(checkPermission('update_kit_received_event'));
    } else if (row.da_log_kit_event === 'Dispensed') {
      setDocumentMetaData(metaDataMock.received_dispensation);
      setPermission(true);
    }
    setID(row.id);
    setUploadedFiles([...row.documents_data]);
    setUploadDilogOpen(true);
  };
  const updateDocs = async (updatedDocIds: string[], isDocDelete = false) => {
    setProgressDocUpload(true);
    try {
      await updateDARDoc({
        event_id: id,
        data: {
          uploaded_file_ids: updatedDocIds
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME
      });
      if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Document Deleted successfuly', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
      }
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
    }
    setProgressDocUpload(false);
    setUploadDilogOpen(false);
    getOverViewDrugData(pageNumber * pageSize, pageSize);
    setID('');
  };

  const sendNotesData = async (id: string) => {
    try {
      await createDARNotes({
        event_id: id,
        data: {
          da_log_kit_notes: notetext,
          created_by: user
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        site_id: selectedSite
      });
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    getNotesData(id);
  };

  useEffect(() => {
    if (getDARNotesError) {
      setNotesData([]);
    }
  }, [getDARNotesError]);
  const getNotesData = async (id: any) => {
    try {
      const res: any = await getDARNotes({ event_id: id });
      const result = res?.data;
      setNotesData(result ? result : []);
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
      setNotesData([]);
    }
  };
  const handleRowClick = (params: any) => {
    if (params.field !== 'action') {
      if (params.row.da_log_kit_event === 'Returned') {
        setValue('4');
      } else if (params.row.da_log_kit_event === 'Destroyed') {
        setValue('5');
      } else if (params.row.da_log_kit_event === 'Quarantined') {
        setValue('7');
      } else if (params.row.da_log_kit_event === 'Transferred') {
        setValue('6');
      } else if (params.row.da_log_kit_event === 'Received') {
        setValue('2');
      } else if (params.row.da_log_kit_event === 'Dispensed') {
        setValue('3');
      }
    }
  };

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Drug Accountability Record-Overview ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const dataTableProps = {
    filterMode: 'server'
  };
  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  return (
    <Box>
      <DataTable
        height="66vh"
        onCellClick={handleRowClick}
        hasDefinedColumns
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
        columns={columns}
        rows={getOverViewData}
        exportCSVName={`Drug Accountability Record-Overview`}
        datePreference={userPreferedDateFormat}
        loading={progress}
        paging
        pageSize={pageSize}
        setPageSize={setPageSize}
        rowsCount={rowsCount}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        paginationMode="server"
        dataTableProps={dataTableProps}
        filterValues={(data: any) => filterValues(data)}
      />
      <Notes
        commentDilogOpen={commentDilogOpen}
        setCommentDilogOpen={setCommentDilogOpen}
        notesData={notesData}
        handleSendNote={handleSendNote}
        notetext={notetext}
        setNoteText={setNoteText}
        permission={notesPermission}
      />
      <DARDocUpload
        documentMetaData={documentMetaData}
        uploadDilogOpen={uploadDilogOpen}
        setUploadDilogOpen={setUploadDilogOpen}
        uploadedFiles={uploadedFiles}
        updateDocs={updateDocs}
        progress={progressDocUpload}
        permission={permission}
      />
    </Box>
  );
};

export default Overview;
